import { useServices } from 'core/services';
import { FilterCommunityMembersInput } from 'core/services/api/api-client/types';
import { transformCommunityMember } from 'core/services/api/transformers';
import { communityKeys } from 'core/utils/query-key-factory';
import { useInfiniteQuery } from '@tanstack/react-query';

export const useGetTeamMembers = (
	id: string,
	input: FilterCommunityMembersInput
) => {
	const { api, authentication } = useServices();
	const isLoggedIn = authentication.isAuthenticated();

	return useInfiniteQuery({
		queryKey: communityKeys.team(id, input),
		queryFn: ({ pageParam }) =>
			api
				.getCommunityMembers(id, input, { after: pageParam })
				.then(response => ({
					members: response.data.map(transformCommunityMember),
					pagination: response.pagination,
				})),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: lastPage => {
			const next = lastPage.pagination?.next;
			if (!next) return undefined;
			return lastPage.members.at(-1)?.identity.uuid;
		},
		enabled: !!id && isLoggedIn,
		placeholderData: previousData => previousData,
	});
};
